module.exports = __webpack_public_path__ + "img/smiley_5.26304208.svg";